export default function ({app, error}) {
    if (app.$planHasPermission('todo_add_to_manual') || app.$planHasPermission('proposal_add_to_manual')) {
      return true;
    }

    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }